<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="global-config-page">
      <el-card v-loading="loading" class="settings-card" shadow="never">
        <div slot="header">
          <div class="settings-title">全局设置</div>
          <div class="settings-hint">设置一级代理的默认返佣比例和默认域名。</div>
        </div>

        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-width="110px">
          <el-form-item label="返佣 (%)" prop="commissionRatio">
            <el-input-number
              v-model="form.commissionRatio"
              :min="0"
              :max="100"
              :step="1"
              :precision="0"
              controls-position="right" />
          </el-form-item>
          <el-form-item label="默认域名" prop="default_domain">
            <el-input
              v-model="form.default_domain"
              placeholder="请输入默认域名"
              clearable />
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              :loading="saving"
              @click="save">
              保存全局设置
            </el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'AgentGlobalConfig',
  data () {
    const validateRatio = (rule, value, callback) => {
      if (value === '' || value === null || value === undefined) {
        return callback(new Error('请输入返佣比例'))
      }
      if (!Number.isInteger(value) || value < 0 || value > 100) {
        return callback(new Error('请输入 0 至 100 之间的整数'))
      }
      callback()
    }

    return {
      loading: false,
      saving: false,
      form: {
        commissionRatio: 0,
        default_domain: ''
      },
      rules: {
        commissionRatio: [
          { validator: validateRatio, trigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.loadConfig()
  },
  methods: {
    loadConfig () {
      this.loading = true
      this.$http.get('/agent_config')
        .then(({ data }) => {
          if (data.code !== 0) {
            return this.$message.error(data.msg)
          }
          this.form.commissionRatio = Number(data.data.commissionRatio || 0)
          this.form.default_domain = data.data.default_domain || ''
        })
        .finally(() => {
          this.loading = false
        })
    },
    save () {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return
        }

        this.saving = true
        this.$http.put('/agent_config', {
          commissionRatio: this.form.commissionRatio,
          default_domain: this.form.default_domain
        }).then(({ data }) => {
          if (data.code !== 0) {
            return this.$message.error(data.msg)
          }
          this.$message.success('全局设置已保存')
          this.loadConfig()
        }).finally(() => {
          this.saving = false
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.global-config-page {
  display: flex;
  justify-content: center;
  padding: 36px 0;
}

.settings-card {
  width: 560px;
}

.settings-title {
  color: #303133;
  font-size: 18px;
  font-weight: 600;
}

.settings-hint {
  margin-top: 8px;
  color: #909399;
  font-size: 13px;
  font-weight: 400;
}

.settings-card ::v-deep .el-card__body {
  padding: 28px 24px 12px;
}

.settings-card ::v-deep .el-input-number {
  width: 220px;
}

.settings-card ::v-deep .el-input {
  width: 360px;
}
</style>
